import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class MiintoCategoryApiClient extends AdvancedApiClient {

    static entityType = "MiintoCategory"

    constructor(token) {
        super();

        this.setEntityType(MiintoCategoryApiClient.entityType)
            .setRoute("/api/v1/miinto/category")
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}